import Vue from 'vue'
import BaseToastContent from './components/BaseToastContent.vue'
import DownloadSkToastContent from './components/DownloadSkToastContent.vue'

export const tipeRequestOptions = [
  { id: 'SWITCH_TALENT', name: 'Switch Talent' },
  { id: 'OFF_TALENT', name: 'Off Talent' },
  { id: 'SWITCH_PARTNER', name: 'Ganti Partner' },
]

export const statusRequestOptions = [
  { id: 'COMPLETED', name: 'Selesai' },
  { id: 'WAITING_PAYMENT', name: 'Menunggu Pembayaran' },
  { id: 'IN_PROGRESS', name: 'On Progress' },
]

const thStyleFirst = {
  textTransform: 'uppercase',
  fontSize: '14px',
  fontWeight: '500',
  color: 'black',
  background: '#F4F4F4',
  lineHeight: '2',
  borderTop: 'none',
  borderBottom: 'none',
  boxShadow: `
    inset 1px 0 0 #ddd,
    inset 0 1px 0 #ddd,
    inset 0 -1px 0 #ddd
  `,
  borderRadius: '15px 0 0 0',
  paddingLeft: '1rem',
}

const thStyleMid = {
  textTransform: 'uppercase',
  textAlign: 'center',
  fontSize: '14px',
  fontWeight: '500',
  color: 'black',
  background: '#F4F4F4',
  lineHeight: '2',
  borderTop: 'none',
  borderBottom: 'none',
  boxShadow: `
    inset 0 1px 0 #ddd,
    inset 0 -1px 0 #ddd
  `,
}

const thStyleLast = {
  textTransform: 'uppercase',
  textAlign: 'center',
  fontSize: '14px',
  fontWeight: '500',
  color: 'black',
  background: '#F4F4F4',
  lineHeight: '2',
  borderTop: 'none',
  borderBottom: 'none',
  boxShadow: `
    inset 0 1px 0 #ddd,
    inset 0 -1px 0 #ddd,
    inset -1px 0 0 #ddd
  `,
  borderRadius: '0 15px 0 0',
}

// eslint-disable-next-line import/prefer-default-export
export const tableFields = [
  {
    key: 'partner_info',
    label: 'Partner & ID',
    thStyle: thStyleFirst,
  },
  {
    key: 'talent_info',
    label: 'Talent Info',
    thStyle: thStyleMid,
    thClass: '!min-w-[200px]',
  },
  {
    key: 'tipe',
    label: 'Tipe',
    thStyle: thStyleMid,
    tdClass: 'text-center',
  },
  {
    key: 'status_invoice',
    label: 'Status Invoice',
    thStyle: thStyleMid,
    tdClass: 'text-center !min-w-[200px]',
  },
  {
    key: 'status_request',
    label: 'Status Request',
    thStyle: thStyleLast,
    tdClass: 'text-center !min-w-[200px]',
  },
]

export const DEFAULT_INCENTIVE = Object.freeze({
  base_salary: '',
  chat_rate_high: '',
  chat_rate_mid: '',
  chat_rate_low: '',
  update_posting_rate: '',
  update_posting_max: 0,
  update_video_rate: '',
  update_video_max: 0,
  update_product_rate: '',
  sales_bonus_percentage: '',
  invoice_rate: '',
  broadcast_rate: '',
  setting_ads_rate: '',
  setting_affiliate_rate: '',
  overtime_rate: '',
  overtime_type: 'hourly',
})

export const SK_CARD_TEXT = Object.freeze({
  CHANGE_TALENT: 'Peralihan Talent',
  CHANGE_PARTNER: 'Peralihan Partner',
})

export const CHURN_ACTION = Object.freeze({
  EDIT_PARTNER: 'Ganti Partner',
  EDIT_TALENT: 'Ganti Talent',
  OFF_TALENT: 'Off Talent',
})

export const INVOICE_ACTION = Object.freeze({
  MAKE_INV: 'Buat Invoice',
  INPUT_INV_NUMB: 'Input Nomor Invoice',
})

export const TYPE_MAP = Object.freeze({
  SWITCH_TALENT: { style: 'badge-tipe--switch' },
  OFF_TALENT: { style: 'badge-tipe--off' },
  SWITCH_PARTNER: { style: 'badge-tipe--ganti' },
})

export const INVOICE_MAP = Object.freeze({
  PAID: { style: 'badge-invoice--lunas', label: 'Lunas' },
  UNPAID: { style: 'badge-invoice--unpaid', label: 'Unpaid' },
  NOT_YET_CREATED: { style: 'badge-invoice--belum', label: 'Belum Dibuat' },
})

export const REQUEST_MAP = Object.freeze({
  COMPLETED: { style: 'badge-request--selesai' },
  CANCELLED: { style: 'badge-request--dibatalkan' },
  WAITING_PAYMENT: { style: 'badge-request--menunggu' },
  IN_PROGRESS: { style: 'badge-request--progress' },
})

const TOAST_CONTENT = {
  BASE: BaseToastContent,
  DOWNLOAD_SK: DownloadSkToastContent,
}

/**
 * Creates toast notification helpers for success/error handling
 */
const createToastNotifier = ({ defaultTitle, defaultIcon, variant }) => (args = {}) => {
  const isObject = typeof args === 'object' && args !== null
  const title = isObject ? (args.title || defaultTitle) : defaultTitle
  const message = isObject
    ? (args.message || (args instanceof Error ? args.message : ''))
    : String(args)
  const options = isObject ? (args.options || {}) : {}
  const timeout = isObject && typeof args.timeout === 'number' ? args.timeout : 2000
  const content = isObject ? (args.content || 'BASE') : 'BASE'
  const onAction = isObject && typeof args.onAction === 'function' ? args.onAction : () => {}

  Vue.$toast(
    {
      component: TOAST_CONTENT[content] || BaseToastContent,
      props: {
        title,
        icon: defaultIcon,
        variant,
        text: message,
        onAction,
        ...options,
      },
    },
    {
      timeout,
      toastClassName: 'lg-rounded-toast',
    },
  )
}

export const showError = createToastNotifier({
  defaultTitle: 'Failure',
  defaultIcon: 'XCircleIcon',
  variant: 'danger',
})

export const showSuccess = createToastNotifier({
  defaultTitle: 'Success',
  defaultIcon: 'CheckCircleIcon',
  variant: 'success',
})
